

import { ClientsFetchAPI } from "../api/Clients";
import ErrorAlert from "../components/Alerts/ErrorAlert";

async function ClientguestValid() {

    

    let machine = "";
    let business = "";
    let branchoffice = "";
    let logo = ""
    let params = false
    let token = undefined
    if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
        logo = localStorage.getItem('logo')
    }
    if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {

    } else {
        params = true
        branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        //setBranchoffice(JSON.parse(localStorage.getItem('branchoffice')))
        machine = JSON.parse(localStorage.getItem('machine'));
        business = JSON.parse(localStorage.getItem("business"));
    }
    let data = {}

    const getClientsByBusiness = async () => {

        try {

            const response = await ClientsFetchAPI.getClientsByBusiness(business.id, token, { skipOwnershipErrorHandler: true })
            
            let dataClients = response.data.data
            let dataGuest = dataClients.find(client => client.name == "Invitado")

            if (dataGuest !== undefined) {
                getClientById(dataGuest.id)
                localStorage.setItem("guestClient", dataGuest.id)
            } else {
                createClient(true)
            }


        } catch (err) {
            //console.log(err);
        }
    }

    const createClient = async (guest) => {
        let token = undefined
        let business = JSON.parse(localStorage.getItem('business'))
        let data = {
            billing_name: "Invitado",
            name: "Invitado",
            phone: "0000000",
            email: "Invitado@Invitado.com",
            nickname: "Invitado",
            password: "",
            ruc: "",
            dv: "",
            passwordCheck: "",
            business_code: business.code,
            client_type_id: 2
        }
        try {
            const response = await ClientsFetchAPI.createClient(data, token, { skipOwnershipErrorHandler: true })
            if (guest == true) {
                localStorage.setItem("guestClient", response.data.client.id)
            }
            getClientById(response.data.client.id)
            localStorage.setItem("guestClient", response.data.client.id)
            ErrorAlert('', 'Usuario creado con exito', 'success')
        } catch (err) {
            ErrorAlert('', err.response.data ? err.response.data.error : "Error al crear usuario", 'error')
            //console.log(err)
        }
    }

    const getClientById = async (client_id, dataOrder) => {
        try {
            const response = await ClientsFetchAPI.getClientsById(client_id, token, { skipOwnershipErrorHandler: true });
            let dataClient = response.data.data;

            let jsonClient = {
                "id": dataClient.id,
                "phone": dataClient.phone,
                "name": dataClient.name,
                "business_id": dataClient.business_id,
                "email": dataClient.email,
                "user_code": dataClient.user_code,
                "gender": dataClient.gender,
                "lastname": dataClient.lastname,
                "cloudinary_id": null,
                "client_type_id": dataClient.client_type_id,
                "client_qr_url": null,
                "ruc": dataClient.ruc,
                "dv": dataClient.dv,
                "client_ruc_type": dataClient.client_ruc_type,
                "localization": null,
                "is_validated": 0,
                "pass": "",
                "nickname": dataClient.nickname,
                "points": 0
            }

            localStorage.setItem('client', JSON.stringify(jsonClient))
            data = jsonClient

        } catch (err) {
            //console.log(err);
        }
    }












    await getClientsByBusiness();
    return data;

}

export default ClientguestValid